export const twitterAutomationKeys = {
    list: (subdomain) => ['twitter-automations', subdomain],
    item: (subdomain, automationId) => ['twitter-automation', subdomain, automationId],
};
